// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailFlowRow_edit_popup__dqDly {
  z-index: 8000;
}

.EmailFlowRow_edit_popup_container__PD\\+si {
  position: fixed !important;
  left: 210px;
  top: 91px;
  width: 290px;
}

/* email row */
.EmailFlowRow_email_row_root__jJ49E {
  margin-top: 10px;
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.EmailFlowRow_email_row_root__jJ49E:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
}

.EmailFlowRow_email_flow_input__0k2Ty {
  background-color: var(--color-bg-caselist-item);
  outline: none;
  border: none;
  color: var(--color-font-10);
  font-weight: bold;
  font-size: 16px;
}

.EmailFlowRow_account_tree_icon__dvJFg {
  margin: 0px 10px;
}

.EmailFlowRow_edit_icon_container__huNwr {
  display: flex;
  justify-content: flex-end;
}

.EmailFlowRow_edit_icon__wpA9P {
  padding: 0px 10px;
}
.EmailFlowRow_warning_icon__0Dz0u {
  color: var(--color-theme-yellow);
}

.EmailFlowRow_edit_icon__wpA9P:hover {
  color: var(--color-font-10);
}

.EmailFlowRow_input_container__uXoJr {
  width: 65%;
}

.EmailFlowRow_flow_list_item__F6yh9 {
  padding: 0px !important;
}

.EmailFlowRow_email_row_root__jJ49E:hover .EmailFlowRow_edit_icon__wpA9P {
  color: var(--color-font-10);
}

/* submenu */
.EmailFlowRow_template_row_root__i0cPF {
  display: flex;
  color: var(--color-theme-10);

  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;

  background-color: var(--color-bg-caselist-item);
  border: 2px solid var(--color-bg-caselist-item);
}

.EmailFlowRow_template_row_root__i0cPF:hover {
  background-color: var(--color-bg-caselist-item-hover);
  border: 2px solid var(--color-bg-caselist-item-hover);
  color: var(--color-font-10) !important;
}

.EmailFlowRow_template_row_root_selected__-X7nh {
  display: flex;
  color: var(--color-theme-10);
  height: 45px;
  cursor: pointer;
  align-items: center;
  padding: 5px;
  background-color: var(--color-bg-caselist-item-selected);
  border: 2px solid var(--color-bg-caselist-item-selected);
}

.EmailFlowRow_status_item__zDROB {
  height: 45px;
  font-size: 12px;
}

.EmailFlowRow_status_icon__thj1b {
  margin: 0px 10px 0px 15px;
}

.EmailFlowRow_status_icon__thj1b svg {
  font-size: 20px !important;
}

.EmailFlowRow_status_title__w3XkB {
  font-size: 13px;
  display: inline-block;
  height: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.EmailFlowRow_delete_template__UxW6V {
  width: 100%;
  display: none;
  justify-content: flex-end;
  color: var(--color-theme-cloud);
}

.EmailFlowRow_add_template_title__CMF56 {
  color: var(--color-theme-silver);
}

.EmailFlowRow_add_template_icon__3h3tX {
  color: var(--color-theme-silver);
}

.EmailFlowRow_template_row_root__i0cPF:hover .EmailFlowRow_add_template_icon__3h3tX {
  color: var(--color-font-10);
}

.EmailFlowRow_template_row_root__i0cPF:hover .EmailFlowRow_add_template_title__CMF56 {
  color: var(--color-font-10);
}

.EmailFlowRow_template_row_root__i0cPF:hover .EmailFlowRow_delete_template__UxW6V {
  display: flex;
  color: var(--color-theme-cloud);
}

.EmailFlowRow_template_row_root_selected__-X7nh .EmailFlowRow_delete_template__UxW6V {
  display: flex;
  color: var(--color-theme-cloud);
}

.EmailFlowRow_delete_icon__BYZVV:hover {
  color: var(--color-theme-blue);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/EmailFlowRow/EmailFlowRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4BAA4B;;EAE5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;;EAEZ,+CAA+C;EAC/C,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".edit_popup {\n  z-index: 8000;\n}\n\n.edit_popup_container {\n  position: fixed !important;\n  left: 210px;\n  top: 91px;\n  width: 290px;\n}\n\n/* email row */\n.email_row_root {\n  margin-top: 10px;\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.email_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n}\n\n.email_flow_input {\n  background-color: var(--color-bg-caselist-item);\n  outline: none;\n  border: none;\n  color: var(--color-font-10);\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.account_tree_icon {\n  margin: 0px 10px;\n}\n\n.edit_icon_container {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.edit_icon {\n  padding: 0px 10px;\n}\n.warning_icon {\n  color: var(--color-theme-yellow);\n}\n\n.edit_icon:hover {\n  color: var(--color-font-10);\n}\n\n.input_container {\n  width: 65%;\n}\n\n.flow_list_item {\n  padding: 0px !important;\n}\n\n.email_row_root:hover .edit_icon {\n  color: var(--color-font-10);\n}\n\n/* submenu */\n.template_row_root {\n  display: flex;\n  color: var(--color-theme-10);\n\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n\n  background-color: var(--color-bg-caselist-item);\n  border: 2px solid var(--color-bg-caselist-item);\n}\n\n.template_row_root:hover {\n  background-color: var(--color-bg-caselist-item-hover);\n  border: 2px solid var(--color-bg-caselist-item-hover);\n  color: var(--color-font-10) !important;\n}\n\n.template_row_root_selected {\n  display: flex;\n  color: var(--color-theme-10);\n  height: 45px;\n  cursor: pointer;\n  align-items: center;\n  padding: 5px;\n  background-color: var(--color-bg-caselist-item-selected);\n  border: 2px solid var(--color-bg-caselist-item-selected);\n}\n\n.status_item {\n  height: 45px;\n  font-size: 12px;\n}\n\n.status_icon {\n  margin: 0px 10px 0px 15px;\n}\n\n.status_icon svg {\n  font-size: 20px !important;\n}\n\n.status_title {\n  font-size: 13px;\n  display: inline-block;\n  height: 18px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n}\n\n.delete_template {\n  width: 100%;\n  display: none;\n  justify-content: flex-end;\n  color: var(--color-theme-cloud);\n}\n\n.add_template_title {\n  color: var(--color-theme-silver);\n}\n\n.add_template_icon {\n  color: var(--color-theme-silver);\n}\n\n.template_row_root:hover .add_template_icon {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .add_template_title {\n  color: var(--color-font-10);\n}\n\n.template_row_root:hover .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.template_row_root_selected .delete_template {\n  display: flex;\n  color: var(--color-theme-cloud);\n}\n\n.delete_icon:hover {\n  color: var(--color-theme-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"edit_popup": `EmailFlowRow_edit_popup__dqDly`,
	"edit_popup_container": `EmailFlowRow_edit_popup_container__PD+si`,
	"email_row_root": `EmailFlowRow_email_row_root__jJ49E`,
	"email_flow_input": `EmailFlowRow_email_flow_input__0k2Ty`,
	"account_tree_icon": `EmailFlowRow_account_tree_icon__dvJFg`,
	"edit_icon_container": `EmailFlowRow_edit_icon_container__huNwr`,
	"edit_icon": `EmailFlowRow_edit_icon__wpA9P`,
	"warning_icon": `EmailFlowRow_warning_icon__0Dz0u`,
	"input_container": `EmailFlowRow_input_container__uXoJr`,
	"flow_list_item": `EmailFlowRow_flow_list_item__F6yh9`,
	"template_row_root": `EmailFlowRow_template_row_root__i0cPF`,
	"template_row_root_selected": `EmailFlowRow_template_row_root_selected__-X7nh`,
	"status_item": `EmailFlowRow_status_item__zDROB`,
	"status_icon": `EmailFlowRow_status_icon__thj1b`,
	"status_title": `EmailFlowRow_status_title__w3XkB`,
	"delete_template": `EmailFlowRow_delete_template__UxW6V`,
	"add_template_title": `EmailFlowRow_add_template_title__CMF56`,
	"add_template_icon": `EmailFlowRow_add_template_icon__3h3tX`,
	"delete_icon": `EmailFlowRow_delete_icon__BYZVV`
};
export default ___CSS_LOADER_EXPORT___;
